/**
 * Store: Quick view
 * -----------------------------------------------------------------------------
 * Tracks what product handle should be displayed in quick view modal.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    handle: '',
  }),

  mutations: {

    /**
     * Set quick view handle.
     * @param {String} handle - Product handle.
     */
    SET_HANDLE(state, handle) {
      state.handle = handle
    },
  },

  actions: {

    /**
     * Set quick view handle.
     * @param {String} handle - Product handle.
     */
    setHandle({ commit, dispatch }, handle = '') {
      commit('SET_HANDLE', handle)

      /**
       * Open quick view overlay if setting a handle.
       */
      if (!handle) {
        return
      }

      const data = {
        component: 'quick-view',
        ignoreDismissed: true,
        namespace: 'quickView',
      }

      dispatch('overlays/open', data, { root: true })
    },
  },
}
